// extracted by mini-css-extract-plugin
module.exports = {"categoryWrapper":"FaqPage_categoryWrapper__3cUP3","categoryHeader":"FaqPage_categoryHeader__B1v6s"};